
import React from "react";
import { StarIcon } from "lucide-react";
import { cn } from "@/lib/utils";

interface ProBadgeProps {
  className?: string;
}

export const ProBadge: React.FC<ProBadgeProps> = ({ className }) => {
  return (
    <div 
      className={cn(
        "inline-flex items-center px-2 py-0.5 text-xs font-medium rounded bg-amber-100 text-amber-800 border border-amber-200",
        className
      )}
    >
      <StarIcon className="h-3 w-3 mr-1" />
      PRO
    </div>
  );
};

export default ProBadge;
